import React, { Component } from 'react';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Button, Grid } from '@material-ui/core';
import DatePicker from '../../../../commonModules/MUI/DatePicker.jsx';

class TransferAvailableStockToResa extends Component {
    state = { disabledSubmit:false}
    
    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.values(SHOPS).map( shop => { 
                let selected = !!shop.shop_disabled || this.props.newResa.shop_id === shop.id
                
                list.push (       
                    {value:shop.id, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }
    prevalidate = () =>{
        this.setState({
            disabledSubmit:true
        }, () =>{
            // Organise la visualisation des produits
            this.props.validate()
        }) 
    }

    render() {
        const shops = this.createShopList()
        console.log('================PROPS RESA====================');
        console.log(this.props.newResa);
        console.log('====================================');
        return (
            <Grid className="card-text">
                <h4 className="card-title">Nouvelle Réservation</h4>

                <Box p={2}>
                    <Grid container spacing={2} >
                        
                        <Grid item xs={12}>
                            <InputSelectMagasin
                                options={shops}
                                value={this.props.newResa.shop_idDisplay}
                                onChange={(option) => this.props.handleSelect(option,"shop_id")}
                                error={this.props.errors.shop_id}
                                label="Magasin"
                                disabled
                            /> 
                        </Grid>                        
                        <Grid item xs={12}>
                            <FormLayout 
                                {...this.props} 
                                title={"Produits"}
                                createAddForm={this.props.createAddForm}
                                onClick={this.props.handleAddProd}
                                onClickForCSVUpload={this.props.handleAddProdByCSV}
                                rea
                                colSpan={2}
                            /> 
                        </Grid>
                        
                    </Grid>
                        
                    <Box p={2} >
                        <div className="pull-right">
                            <Button color="secondary" variant="contained" onClick={this.prevalidate} disabled={this.state.disabledSubmit}>{this.state.disabledSubmit ? 'Traitement en cours...' :  "Valider"}</Button>
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>                    
                    </Box>
                </Box>
            </Grid>
        );
    }
}

export default TransferAvailableStockToResa;